import { useEffect, useState } from "react";
import { CloseIcon, EditPenIcon } from "../SVGs";

const InputWithPen = ({small=false,label,required,placeholder,val="",onClear,onClickOnPencil,penBtnDisabled,showClearIcon=true,penIconColor="#0D6EFD"}) => {
  const [value, setValue] = useState('');

  const handleClear = () => {
    setValue('')
    if(onClear)onClear()
  };

  useEffect(()=>{
    setValue(val)
  },[val])

  return (<>
    {
      label && <><label>{label}{required && <span className="required">*</span>}</label></>
    }
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        // padding: '4px 8px',
        width: '100%',
        background: '#fff',
        height:small ? "25px" :"",
        justifyContent:"space-between"
      }}
    >
      <input
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          fontSize: '14px',
          background: 'transparent',
        }}
        disabled={true}
      />
      {(value && showClearIcon)&& (
        <span
          onClick={handleClear}
          style={{
            cursor: 'pointer',
            marginRight: '10px',
          }}
        >
          <CloseIcon />
        </span>
      )}
      <span
        style={{
          backgroundColor: "#E9ECEF",
          padding: small ? "4px" : "7px",
          borderTopRightRadius:"4px",
          borderBottomRightRadius:"4px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: penBtnDisabled ? "not-allowed" : "pointer",
          opacity: penBtnDisabled ? 0.5 : 1,
        }}
        title="Edit"
        onClick={!penBtnDisabled ? onClickOnPencil:()=>{}}
      >
        <EditPenIcon width={small ? "15" :"18"} height={small ? "15" :"18"} color={penIconColor} />
      </span>
    </div>
  </>
  );
};


export default InputWithPen